module.exports = function() {
  return new Worker(__webpack_public_path__ + "0753cbfa86278a6fe6b7.worker.js");
};